import { Button } from '@insify/design-system/components';
import { IconicSparkles2 } from '@insify/design-system/iconic-icons';
import { ContentContextWrapper } from '@objectiv/tracker-react';
import clsx from 'clsx';

import { useAssistantChat } from '../../../api/getChat';
import { useChatStore } from '../../../stores/chatStore';

import styles from './SuggestedQuestions.module.css';

interface SuggestedQuestionsProps {
  suggestedQuestions?: string[] | null;
}
export const SuggestedQuestions: React.FC<SuggestedQuestionsProps> = () => {
  const addUserMessage = useChatStore.use.sendMessage();
  const suggestedQuestions = useChatStore.use.relatedQuestions();
  const setRelatedQuestions = useChatStore.use.setRelatedQuestions();
  const activeSlideIndex = useChatStore.use.activeSlideIndex();
  const { mutate: sendMessage } = useAssistantChat();

  return (
    suggestedQuestions &&
    suggestedQuestions.filter((q) => q.trim() !== '').length > 0 && (
      <ContentContextWrapper id='suggested-questions'>
        <div className={styles.container}>
          {suggestedQuestions.map((question, index) => (
            <Button
              kind='secondary'
              type='button'
              key={question
                .toLowerCase()
                .replace(/[^a-z0-9\s]/g, '')
                .replace(/\s+/g, '-')}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                addUserMessage(question);
                sendMessage({ message: question });
                setRelatedQuestions(suggestedQuestions.filter((q) => q !== question));
              }}
              className={clsx(styles.questionButton)}
              leftIcon={<IconicSparkles2 fill='var(--dark-90)' />}
              trackingId={`slide-${activeSlideIndex + 1}-suggested-question-${index + 1}}`}
            >
              {question}
            </Button>
          ))}
        </div>
      </ContentContextWrapper>
    )
  );
};
